module.exports = __webpack_public_path__ + "static/media/webpack.837b970d.svg";